import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ToastVariant = "success" | "error";

/** An optional button on a toast ("Undo"); its callback is in toastActions.ts. */
export interface ToastAction {
    id: string;
    label: string;
}

export interface ToastMessage {
    id: string;
    variant: ToastVariant;
    message: string;
    action?: ToastAction;
}

interface ToastState {
    items: ToastMessage[];
}

const initialState: ToastState = {
    items: []
};

let toastSequence = 0;
const nextToastId = () => `toast-${Date.now()}-${toastSequence++}`;

const toastSlice = createSlice({
    name: "toast",
    initialState,
    reducers: {
        showToast: {
            reducer(state: ToastState, action: PayloadAction<ToastMessage>) {
                state.items.push(action.payload);
            },
            prepare(variant: ToastVariant, message: string, action?: ToastAction) {
                return { payload: { id: nextToastId(), variant, message, ...(action ? { action } : {}) } };
            }
        },
        dismissToast(state: ToastState, action: PayloadAction<string>) {
            state.items = state.items.filter((item) => item.id !== action.payload);
        }
    }
});

export const { showToast, dismissToast } = toastSlice.actions;
export default toastSlice.reducer;
